export interface EQDocument {
  uid: number;
  guid: string;
  companyUID: number;
  type: number; // 서식타입 0 - 공정위험성평가, 1 - 작업위험성평가, 2 - 작업자교육, 3 - 화기작업허가서, 4 - 일반작업허가서, 5 - 변경요구서, 6 - 가동전점검표, 7- 변경구분평가
  fileType: number;
  description: string;
  fileName: string;
  extension: string;

  typeUID: number; // Deprecated - 사용되지 않음
  subType: number; // Deprecated - 사용되지 않음

  isDeleted: boolean;
  entryDate: Date | string;
  modifyDate: Date | string;

  revisionDate: Date | string;

  // NOT DB
  base64: string;
}

export const initializeDocument = (): EQDocument => {
  return {
    uid: 0,
    guid: "00000000-0000-0000-0000-000000000000",
    companyUID: 0,
    type: 0, // 서식타입 0 - 공정위험성평가, 1 - 작업위험성평가, 2 - 작업자교육, 3 - 화기작업허가서, 4 - 일반작업허가서, 5 - 변경요구서, 6 - 가동전점검표, 7- 변경구분평가
    fileType: 0,
    description: "",
    fileName: "",
    extension: "",

    typeUID: 0, // Deprecated - 사용되지 않음
    subType: 0, // Deprecated - 사용되지 않음

    isDeleted: false,
    entryDate: new Date(),
    modifyDate: new Date(),
    revisionDate: new Date(),

    // NOT DB
    base64: "",
  };
};

export interface DocumentListParams {
  id: number;
  page: number;
  token: string;
  rows?: number; // 표시 행 수
}

export const initializeDocumentListParams = {
  id: 0,
  page: 1,
  token: "",
  rows: 20, // 표시 행 수
};

export const documentTypeName = [
  "공정위험성평가",
  "작업위험성평가",
  "작업자교육",
  "화기작업허가서",
  "일반작업허가서",
  "변경요구서",
  "가동전점검표",
  "변경구분평가",
];
